<template>
	<div class="app-container app-padding-top-84">
		<personal-message-navigate />
		<div class="app-margin-top-45" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<personal-message-announcement class="app-margin-top-18" v-for="item in informList" :key="item.id" :data="item" />
		</div>
	</div>
</template>

<script>
import personalMessageAnnouncement from '../../../components/personal/message/announcement.vue';
import personalMessageNavigate from '../../../components/personal/message/navigate.vue';
import service from '../../../service/index';

export default {
	inject: ['reload'],
	components: {
		personalMessageAnnouncement,
		personalMessageNavigate
	},
	data() {
		return {
			informList: [],
			loading: true
		};
	},
	mounted() {
		this.getInfo();
	},
	methods: {
		getInfo() {
			let status = '1';
			service.announcementList(status, res => {
				this.loading = false;
				if (res.code === 200) {
					for (let item of res.data) {
						let now = new Date();
						let inputDate = Date.parse(item.overTime); //输入时间戳
						let expirationTime = now.setTime(inputDate); //要过期的时间
						let currentTime = new Date().getTime(); // 当前时间
						if (currentTime < expirationTime) {
							this.informList.push(item);
						}
					}
				}
			});
		}
	}
};
</script>

<style scoped>
.app-container {
	width: 1225px;
}
</style>
